import { Grid } from "@mui/material";

//import general components
import Footer from "../../components/common/footer/footer";

//import view components
import AboutUsBlog from "../../components/view/about-us/about-us-blog/about-us-blog";

//import styles
import "./about-us.scss";

function AboutUs() {
    return (
        <>
            <Grid className="about-us" mt={{ xs: 2, md: 0 }} mb={15}>
                <Grid container rowGap={5} mb={{ xs: 15, md: 5 }}>
                    <AboutUsBlog />
                </Grid>
            </Grid>
            <Footer />
        </>
    );
}
export default AboutUs;
